<template>
    <div>
        <template v-if="uiStore.isMobile || uiStore.isTablet">
            <div class="content-container">
                <div class="mb-2">
                    <placeholder size="sm" :width="5"/>
                </div>
                <h1>{{ name }}</h1>
            </div>

            <div class="vh-40 mt-3">
                <div class="d-flex align-items-center justify-content-center border text-muted h-100">
                    <div style="width:64px; height:64px;">
                        <marquis-circle-icon/>
                    </div>
                </div>
            </div>

            <div class="mt-3 content-container">
                <ui-button :placeholder="true" :outline="true" class="me-3">
                    Show All Photos
                </ui-button>
            </div>
        </template>

        <div v-else class="content-container">
            
            <div class="mb-2">
                <placeholder size="sm" :width="5"/>
            </div>
            <h1>{{ name }}</h1>
            
            <container>
                <row>
                    <column :col="12">

                        <div class="h-100 rounded border d-flex align-items-center justify-content-center text-muted">
                            <div style="width:64px; height:64px;">
                                <marquis-circle-icon/>
                            </div>

                        </div>

                    </column>
                    <column :col="12" >

                        <container>
                            <row>
                                <column v-for="imageKey in 4" :key="`placehoder-property-header-side-images-${imageKey}`" :col="12">
                                    <div class="border rounded aspect-ratio-4x3 mb-3 d-flex align-items-center justify-content-center text-muted">
                                        <div style="width:32px; height:32px;">
                                            <marquis-circle-icon/>
                                        </div>
                                    </div>
                                </column>
                            </row>
                        </container>

                        <div class="d-flex align-items-center">
                            <ui-button :placeholder="true" :outline="true" class="me-3">
                                Show All Photos
                            </ui-button>
                        </div>
                    </column>
                </row>
            </container>
        </div>

        
    </div>
</template>

<script type="text/javascript">
    import MarquisCircleIcon from '@/assets/logos/marquis-circle-icon.svg.vue';
    import CommonComponents from '@/components/Common.vue';
    import Utilities from '@/classes/Utilities.js';

    import { UseUIStore } from '@/store/UI.js';

    export default {
        components: {
            MarquisCircleIcon,
            ...CommonComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        computed: {
            name() {
                if (
                    (this.$route.params) &&
                    (this.$route.params.slug) &&
                    (typeof this.$route.params.slug == 'string')
                ) {
                    let slug = this.$route.params.slug.replace(' b-b ', ' B&B ');
                    slug = slug.replace('-s-', "'s ");
                    return Utilities.ucWords(slug, '-', ' ');
                }

                return null;
            }
        },
    };

</script>
